import { render, staticRenderFns } from "./RoundedInstagramIcon.vue?vue&type=template&id=7f004fee"
import script from "./RoundedInstagramIcon.vue?vue&type=script&lang=js"
export * from "./RoundedInstagramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports